import { PortalPlugin } from './PortalPlugin';

/**
 * This function is used to register with the app, it is intentionally coupled through global variables
 * so that the plugin does not need to bundle the app into itself as a dependency
 */
export const register = (plugin: PortalPlugin) => {
  (window as any).__registerAsurePortalPlugin(plugin);
};

// see AccountData in models (which is likely added to IOC in App)
export class IAccountData {
  givenName: string;
  surname: string;
}

// see Tenant in models
export class ITenantData {
  id: string; // uuid
  name: string;
  subdomain: string;
}



// WEBPACK FOOTER //
// ./src/framework/production.ts